import { Collapse } from 'module/ui/components/atoms/collapse';
import { Panel } from 'module/ui/components/atoms/collapse/panel';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { HeadingCompact01, Short01 } from 'module/ui/components/styles';
import {
  faChevronDown,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

const CollapsibleSection = styled(Collapse).attrs({
  expandIcon: ({ isActive }) => {
    return isActive ? (
      <FontAwesomeIcon icon={faChevronDown} size={12} />
    ) : (
      <FontAwesomeIcon icon={faChevronRight} size={12} />
    );
  },
})`
  .ant-collapse-item {
    &.ant-collapse-item-active {
      padding-bottom: 0;
    }
    .ant-collapse-header {
      padding: 0;
      .ant-collapse-arrow {
        margin-right: var(--spacing-02);
        color: var(--icon-secondary);
      }
    }
  }
  .ant-collapse-content.ant-collapse-content-active {
    padding-top: var(--spacing-03);
  }
`;
const CollapsibleSectionHeader = styled.div`
  ${HeadingCompact01};
`;

interface CollapsibleProps {
  children: React.ReactNode;
  title: React.ReactNode;
  panelKey: string;
}
export const Collapsible = ({
  children,
  title,
  panelKey,
}: CollapsibleProps) => {
  return (
    <CollapsibleSection defaultActiveKey={panelKey}>
      <Panel
        key={panelKey}
        header={<CollapsibleSectionHeader>{title}</CollapsibleSectionHeader>}
      >
        {children}
      </Panel>
    </CollapsibleSection>
  );
};

export const EmptyContent = styled.div`
  ${Short01};
  color: var(--text-tertiary);
`;
